module.exports = __webpack_public_path__ + "img/shenzhen17.f73a0c80.jpg";